import { useState } from "react";
import { HiOutlineExclamationCircle } from "react-icons/hi";
import { AnimatePresence, motion } from "framer-motion";

export function InsuranceNotice() {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="flex flex-col gap-2 mt-4 p-4 bg-blue-50 border-l-4 border-blue-400 rounded-lg text-sm text-blue-900 shadow-sm">
      {/* Main Content */}
      <div className="flex items-start gap-3">
        <HiOutlineExclamationCircle className="w-5 h-5 mt-0.5 flex-shrink-0 text-blue-600" />
        <div className="flex flex-col gap-1">
          <span className="font-semibold text-blue-900">
            Limited insurance coverage
          </span>
          <span className="text-blue-800 flex items-center gap-2 flex-wrap">
            Shipping prices include the carrier’s default coverage.
            <button
              onClick={() => setExpanded(!expanded)}
              className="text-xs font-medium text-blue-700 bg-blue-100 hover:bg-blue-200 px-2 py-0.5 rounded-full transition-colors"
            >
              {expanded ? "Hide details ▲" : "Learn more ▼"}
            </button>
          </span>
        </div>
      </div>

      {/* Animated Details */}
      <AnimatePresence initial={false}>
        {expanded && (
          <motion.div
            key="details"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.2 }}
            className="overflow-hidden mt-2 text-xs text-blue-700 leading-relaxed space-y-1"
          >
            <p>
              Default coverage protects against certain types of loss or damage. Coverage limits vary by carrier and service.
            </p>
            <p>
              We do not sell additional insurance. If you want coverage beyond the carrier’s default maximum, you must purchase it from a third-party provider.
            </p>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}